import { createReducer } from 'src/utils/reducer'
import * as actions from '../../../constants/actionTypes'

const reduceTeam = (acc, team) => ({ ...acc, [team.id]: team })
const teams = createReducer(
    {
        byId: {},
        values: [],
        searchResults: [],
        loading: false,
    },
    {
        [actions.GET_RUNBOOKS_SUCCESS]: (state, action) => ({
            ...state,
            byId: {
                ...action.payload.data.results.reduce(
                    (acc, cur) => {
                        let result = { ...acc }
                        cur.adminTeams.forEach((team) => {
                            result = reduceTeam(result, team)
                        })
                        return result
                    },
                    { ...state.byId }
                ),
            },
            values: [
                ...state.values,
                ...action.payload.data.results.reduce(
                    (acc, cur) => [
                        ...acc,
                        ...cur.adminTeams.map((team) => team.id),
                    ],
                    []
                ),
            ].filter((value, index, self) => self.indexOf(value) === index),
        }),
        [actions.GET_CMDB_TEAMS_SUCCESS]: (state, action) => ({
            ...state,
            byId: {
                ...action.payload.data.results
                    .filter((t) => t.exists)
                    .reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {
                        ...state.byId,
                    }),
            },
            values: [
                ...state.values,
                ...action.payload.data.results
                    .filter((t) => t.exists)
                    .map((team) => team.id),
            ].filter((value, index, self) => self.indexOf(value) === index),
        }),
        [actions.GET_RUNBOOK_RECEIVED]: (state, action) => ({
            ...state,
            byId: {
                ...action.data.runbook.adminTeams.reduce(
                    (acc, cur) => ({
                        ...acc,
                        [cur.id]: { ...cur, exists: true },
                    }),
                    { ...state.byId }
                ),
            },
            values: [
                ...state.values,
                ...action.data.runbook.adminTeams.map((team) => team.id),
            ].filter((value, index, self) => self.indexOf(value) === index),
        }),
    }
)

export const getTeam = (state, teamId) => state.teams.byId[teamId]

export default teams
